import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { TaxService } from 'src/app/services/Tax.service';
import { TaxGroupService } from 'src/app/services/taxGroup.service';
import { EActionTypes, EElementTypes } from '../enum';
import { ICodeExists, IStore, ITax, ITaxOptions } from '../interface';
import { TempDataService } from '../tempData.service';

@Component({
    selector: 'app-tax-group',
    templateUrl: './tax-group.component.html',
    styleUrls: ['./tax-group.component.scss'],
    standalone: false
})
export class TaxGroupComponent implements OnInit {

  @Input() taxGroupId;
  @Input() fromPage;
  @Input() facilityId;
  @Input() independentTaxIds;
  @Output() isFormDirty: EventEmitter<any> = new EventEmitter<any>();
  @Output() isTaxGroupSaved: EventEmitter<any> = new EventEmitter<any>();
  @Output() savedTaxGroupId: EventEmitter<any> = new EventEmitter<any>();
  invalidTaxName = "";
  @ViewChild('invalidTaxPopUp', { static: true }) invalidTaxPopUp: ModalDirective;
  @ViewChild('deleteTaxGrouoPopUp', { static: true }) deleteTaxGrouoPopUp: ModalDirective;


  @ViewChild('taxgroupsetting', { static: true }) public selectedValue: DropDownListComponent;

  public waterMark = 'Select Settings';
  public fields: Object = { text: 'Name', value: 'Id' };
  public settingsDropdownData: { [key: string]: Object }[] = [
    { Id: 1, Name: 'Assign Tax' },
    { Id: 2, Name: 'Assign Facility' }
  ];

  public dataLoaded: Promise<boolean>;
  public loaderIcon: Promise<boolean>;
  showDropIcon: true;
  selectedOpt = 1;
  StoreSelection = 'AvailableStore';
  TaxSelection = 'Taxes';
  taxGroupForm: FormGroup;
  StorageFacilities: FormArray = this.formBuilder.array([]);
  SeletedTaxList: FormArray = this.formBuilder.array([]);
  taxOptionsList = [];
  isTaxGroupNameExist: boolean;
  isReactivation: boolean;
  isTaxGroupNameExistsInDeleted: boolean;
  currentTaxGroupName: any;
  isEdit: boolean;
  availableLocations = [];
  taxGroupDetails: any;
  allTaxList;
  moduleName = "Taxes"
  initialAllTaxList = [];
  @ViewChild('conformationPopUp', { static: true }) conformationPopUp: ModalDirective;
  @ViewChild('cancelConformationPopUp', { static: true }) cancelConformationPopUp: ModalDirective;
  @ViewChild('reactivePopUp', { static: true }) reactivePopUp: ModalDirective;
  @ViewChild('taxValidationPopUp', { static: true }) taxValidationPopUp: ModalDirective;
  @ViewChild('taxOptionValidationPopUp', { static: true }) taxOptionValidationPopUp: ModalDirective;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  modalConfig = {
  backdrop: 'static'
};
  invalidFacilityId = 0;
  allStores: IStore[];
  eNumElementTypes = EElementTypes;
  eNumActionTypes = EActionTypes;

  constructor(
    private formBuilder: FormBuilder,
    public taxService: TaxService,
    public taxGroupService: TaxGroupService,
    private router: Router,
    private toastr: ToastrService,
    public tempDataService: TempDataService) { }


  ngOnInit() {
    if (this.taxGroupId > 0) {
      this.getTaxGroupDetails();
    } else {
      this.getTaxLists();
      this.getStores();

    }
    this.taxGroupForm = this.formBuilder.group({
      Id: this.taxGroupId === 0 ? '' : this.taxGroupId,
      TaxGroupName: ['', [Validators.required]],
      TaxOption: ['', Validators.required],
      TotalPercentage: [''],
      StorageFacilities: this.StorageFacilities,
      SeletedTaxList: this.SeletedTaxList
    })
    this.getTaxOptions();

    if (this.fromPage == 'StoreInfoTax') {
      this.settingsDropdownData = [
        { Id: 1, Name: 'Assign Tax' },
      ];
    }

  }

  getTaxGroupDetails() {
    this.taxGroupService.getTaxGroupdetails(this.taxGroupId).subscribe(res => {
      this.taxGroupDetails = res;
      this.taxGroupForm.get("TaxGroupName").patchValue(this.taxGroupDetails.TaxGroupName);
      this.currentTaxGroupName = this.taxGroupDetails.TaxGroupName;
      this.taxGroupForm.get("TaxOption").patchValue(this.taxGroupDetails.OptionId);
      this.availableStoreList(this.taxGroupDetails.OptionId);
      this.getStores();
      this.getTaxLists();
    })
  }

  getTaxOptions() {
    this.taxService.getTaxOptions().subscribe((response: ITaxOptions[]) => {
      this.taxOptionsList = response;
    });
  }

  showSelectedOption(eve) {
    this.selectedOpt = +this.selectedValue.value;
    eve.item.childNodes[0].children[1].classList.add('displayImage');
  }

  addimageForFirst(eve) {
    const img = eve.popup.element.childNodes[0].children[0].children[0].children[0].children[1].classList.add('displayImage');
  }

  isTaxGroupNameExists(val) {
    this.isTaxGroupNameExist = false;
    this.isReactivation = false;
    this.isTaxGroupNameExistsInDeleted = false;

    if (this.currentTaxGroupName !== val && val.trim() !== '') {
      this.taxGroupService.isTaxGroupNameExists(val).subscribe((response: ICodeExists) => {
        if (response === null) {
          this.isTaxGroupNameExist = false;
        } else {
          if (response.DeleteFlag === false) {
            this.isTaxGroupNameExist = true;
          } else if (response.DeleteFlag === true) {
            this.isTaxGroupNameExist = false;// TODO -- need to remove
            this.isReactivation = true;
            if (this.isEdit === false) {
            } else {
              this.isTaxGroupNameExistsInDeleted = true;
            }
          }
        }
      });
    } else {
      this.isTaxGroupNameExist = false;
    }
  }

  getStores() {
    this.allStores = this.tempStoreServiceGet ? JSON.parse(JSON.stringify(this.tempStoreServiceGet)) : [];
    let activeScheduleLocations = [];
    if (this.taxGroupDetails) {
      this.taxGroupDetails.StorageFacilities.forEach((ele) => {
        this.StorageFacilities.push(this.formBuilder.control(''));
      });
      this.taxGroupDetails.StorageFacilities.forEach(ss => {
        let tempLocation = this.allStores.find(al => al.Id === ss);
        if (tempLocation) {
          activeScheduleLocations.push(tempLocation);
        }
      });
      this.taxGroupForm.patchValue({ StorageFacilities: activeScheduleLocations })
      this.dataLoaded = Promise.resolve(true);
    }
  }
  get tempStoreServiceGet() {
    return this.tempDataService.storeList;
  }

  availableStoreList(taxGroupId) {
    this.dataLoaded = Promise.resolve(false);
    this.taxGroupService.availableStoreList(taxGroupId).subscribe(response => {
      this.availableLocations = response;
      this.dataLoaded = Promise.resolve(true);
    })
  }

  saveTaxGroup() {
    let activeStorageFacilities = this.taxGroupForm.value.StorageFacilities.filter(d => d.Id > 0);
    let activeTaxList = this.taxGroupForm.value.SeletedTaxList.filter(t => t.Id > 0)

    let activeFacilityIds = activeStorageFacilities.map((obj) => obj.Id);
    let activeTaxes = activeTaxList.map(t => t.Id);

    let saveGroupTaxObj = {
      TaxGroupId: this.taxGroupId,
      TaxGroupName: this.taxGroupForm.value.TaxGroupName,
      OptionId: this.taxGroupForm.value.TaxOption,
      TaxIds: activeTaxes,
      StorageFacilities: this.fromPage == 'StoreInfoTax' ? [this.facilityId] : activeFacilityIds,
    }

    this.loaderIcon = Promise.resolve(true)
    this.taxGroupService.saveTaxGroup(saveGroupTaxObj).subscribe(res => {
      if (res.Success) {
        this.savedTaxGroupId.emit(res.Id);
        this.toastr.success('Tax Group saved successfully', 'Success', this.toasterConfig);
        this.isTaxGroupSaved.emit(true);
        this.conformationPopUp.hide();
      } else {
        this.toastr.error('Failed to save Tax Group', 'Failure', this.toasterConfig);
        this.isTaxGroupSaved.emit(false);
      }
      this.loaderIcon = Promise.resolve(false)
    })
  }

  setDirtyFlag(eve) {
    let activeTaxList = this.taxGroupForm.value.SeletedTaxList.filter(t => t.Id > 0)
    let totalTaxPercentage = 0;
    activeTaxList.forEach(tax => {
      totalTaxPercentage = totalTaxPercentage + tax.Percentage;
    })

    this.taxGroupForm.get('TotalPercentage').setValue(totalTaxPercentage.toFixed(2));
  }

  getTaxLists() {
    this.taxService.getTaxLists().subscribe((response: ITax[]) => {
      let indefiniteTaxes = response.filter(t => t.ActiveTill == 'Indefinite');
      let activeTillTaxes = response.filter(t => t.ActiveTill !== 'Indefinite');
      let liveTaxes = activeTillTaxes.filter(t => new Date(t.ActiveTill) >= new Date());
      this.allTaxList = liveTaxes.concat(indefiniteTaxes);
      this.initialAllTaxList = this.allTaxList;
      let activeTaxes = [];
      if (this.taxGroupDetails) {

        this.taxGroupDetails.TaxIds.forEach((ele) => {
          this.SeletedTaxList.push(this.formBuilder.control(''));
        });
        this.taxGroupDetails.TaxIds.forEach(ss => {
          let tempLocation = this.allTaxList.find(al => al.Id === ss);
          if (tempLocation) {
            activeTaxes.push(tempLocation);
          } else {
            this.SeletedTaxList.removeAt(0);
          }
        })

        let tempTaxes = [];
        this.taxGroupForm.patchValue({ SeletedTaxList: activeTaxes })

        if (activeTaxes.length > 0) {
          let totalPercentage = 0;
          activeTaxes.forEach(t => {
            totalPercentage = totalPercentage + t.Percentage;
          });

          if (totalPercentage > 0) {
            this.taxGroupForm.get('TotalPercentage').setValue(totalPercentage.toFixed(2));
          }
        }

        this.taxGroupDetails.TaxIds.forEach(tId => {
          let index = this.allTaxList.findIndex(at => at.Id == tId);
          this.allTaxList.splice(index, 1)
        });
        this.onTaxOptionChange(this.taxGroupDetails.OptionId, '')
      }

      this.loaderIcon = Promise.resolve(false);
      this.dataLoaded = Promise.resolve(true);

    });
  }

  onTaxOptionChange(value, from) {
    let taxOption = this.taxOptionsList.find(to => to.Id === +value)
    if (taxOption) {
      this.allTaxList = this.initialAllTaxList.filter(t => t.TaxOption === taxOption.Name);
      if (from == 'DropDown') {
        this.SeletedTaxList = this.formBuilder.array([]);
        this.StorageFacilities = this.formBuilder.array([]);

        this.taxGroupForm = this.formBuilder.group({
          Id: this.taxGroupId === 0 ? '' : this.taxGroupId,
          TaxGroupName: this.taxGroupForm.value.TaxGroupName,
          TaxOption: this.taxGroupForm.value.TaxOption,
          TotalPercentage: [''],
          StorageFacilities: this.StorageFacilities,
          SeletedTaxList: this.SeletedTaxList
        })
      }
      this.availableStoreList(value);
      this.dataLoaded = Promise.resolve(true);
    }
  }

  saveConformaionPop() {
    // Condition for Tax Option already saved for the facility in Store info tax
    if (this.fromPage == "StoreInfoTax") {

      let isFacilityAvailable = this.availableLocations.find(s => s.Id == this.facilityId)
      if (isFacilityAvailable) {
        this.validationsForTaxGroup();
      } else {
        this.taxOptionValidationPopUp.show();
      }

    } else {
      this.validationsForTaxGroup();
    }
  }

  validationsForTaxGroup() {
    let activeStorageFacilities = this.taxGroupForm.value.StorageFacilities.filter(d => d.Id > 0);
    let activeTaxList = this.taxGroupForm.value.SeletedTaxList.filter(t => t.Id > 0)

    let activeFacilityIds = activeStorageFacilities.map((obj) => obj.Id);
    let activeTaxes = activeTaxList.map(t => t.Id);

    // Remove already saved Facilities
    if (this.taxGroupDetails) {
      this.taxGroupDetails.StorageFacilities.forEach(sId => {
        let index = activeFacilityIds.findIndex(i => i == sId);
        if (index >= 0) {
          activeFacilityIds.splice(index, 1);
        }
      });
    }

    if (activeTaxList.length < 2) {
      this.taxValidationPopUp.show();
    } else {
      this.taxGroupService.getTaxAppliedforFacility(this.taxGroupForm.value.TaxOption).subscribe(res => {
        let result = res;

        if (res.length > 0) {

          if (this.fromPage == "StoreInfoTax") {
            if (this.independentTaxIds) {
              this.independentTaxIds.forEach(tId => {
                let tax = activeTaxes.includes(tId);
                if (tax) {
                  this.invalidTaxName = this.allTaxList.find(t => t.Id == tId) ? this.allTaxList.find(t => t.Id == tId).Name : "";
                  this.invalidFacilityId = this.facilityId;
                  this.invalidTaxPopUp.show();
                }
              });
            }

            let isInvalid = false;

            res.forEach(ivt => {
              if (this.facilityId == ivt.FacilityId) {
                ivt.TaxIds.forEach(tId => {
                  let tax = activeTaxes.includes(tId);
                  if (tax) {
                    isInvalid = true;
                    this.invalidTaxName = this.allTaxList.find(t => t.Id == tId) ? this.allTaxList.find(t => t.Id == tId).Name : "";
                    this.invalidFacilityId = this.facilityId;

                  }
                });
              }

            })

            if (isInvalid) {
              this.invalidTaxPopUp.show();
            } else {
              if (this.isTaxGroupNameExistsInDeleted) {
                this.reactivePopUp.show();
              } else {
                this.conformationPopUp.show();
              }
            }

          } else {
            let isInvalidTax = false;
            res.forEach(ivt => {
              if (activeFacilityIds.includes(ivt.FacilityId)) {
                ivt.TaxIds.forEach(tId => {
                  let tax = activeTaxes.includes(tId);
                  if (tax) {
                    isInvalidTax = true;
                    this.invalidTaxName = this.allTaxList.find(t => t.Id == tId) ? this.allTaxList.find(t => t.Id == tId).Name : "";
                    this.invalidFacilityId = ivt.FacilityId
                  }
                });
              }

            })
            if (isInvalidTax) {
              this.invalidTaxPopUp.show();
            } else {
              if (this.isTaxGroupNameExistsInDeleted) {
                this.reactivePopUp.show();
              } else {
                this.conformationPopUp.show();
              }
            }
          }



        } else {
          let isInvalid = false;
          if (this.fromPage == "StoreInfoTax") {
            if (this.independentTaxIds) {
              this.independentTaxIds.forEach(tId => {
                let tax = activeTaxes.includes(tId);
                if (tax) {
                  isInvalid = true
                  this.invalidTaxName = this.allTaxList.find(t => t.Id == tId) ? this.allTaxList.find(t => t.Id == tId).Name : "";
                  this.invalidFacilityId = this.facilityId
                }
              });
            }

            if (isInvalid) {
              this.invalidTaxPopUp.show();
            } else {
              if (this.isTaxGroupNameExistsInDeleted) {
                this.reactivePopUp.show();
              } else {
                this.conformationPopUp.show();
              }
            }
          }
        }
      })
    }

  }

  openCancelConformation() {
    if (this.taxGroupForm.dirty) {
      this.cancelConformationPopUp.show();
    } else {
      this.isTaxGroupSaved.emit(true);

    }

  }

  deleteTaxGroup() {
    this.loaderIcon = Promise.resolve(true);

    this.taxGroupService.deletetaxGroup(this.taxGroupId).subscribe(res => {
      this.deleteTaxGrouoPopUp.hide();
      if (res.Success) {
        this.toastr.success('Tax Group deleted Successfully', 'Success', this.toasterConfig);
      } else {
        this.toastr.error('Failed to delete Tax Group', 'Failure', this.toasterConfig);
      }

      this.isTaxGroupSaved.emit(true);
      this.loaderIcon = Promise.resolve(false);

    })
  }

  back() {
    if (this.fromPage == 'StoreInfoTax') {
      this.cancelConformationPopUp.hide();
      this.isTaxGroupSaved.emit(false);
    } else {
      this.router.navigate(['ac/txgl']);
    }
  }

  initialiseTaxGroupComponent() {
    this.SeletedTaxList = this.formBuilder.array([]);
    this.taxGroupForm.reset();
    this.getTaxLists();
  }


  getStoreName(id) {
    if (this.allStores && id > 0) {
      return this.allStores.find(f => f.Id == id).Name ? this.allStores.find(f => f.Id == id).Name : ""
    } else {
      return ""
    }
  }

  getTaxOptionName() {
    if (this.taxOptionsList.length > 0 && +this.taxGroupForm.value.TaxOption > 0) {
      return this.taxOptionsList.find(to => to.Id == +this.taxGroupForm.value.TaxOption).Name ? this.taxOptionsList.find(to => to.Id == +this.taxGroupForm.value.TaxOption).Name : ""
    } else {
      return "";
    }
  }
}
